<div class="container">
    <div class="sidebar">
        <!-- Left Side bar content -->
      </div>
    <div class="content" [ngClass]="{ 'hide-dealer-image': dealerImageDisplay }" (swipeleft)="onSwipeLeft($event)" (swiperight)="onSwipeRight($event)">
      @if(!isLargeScreen){
        <div class="header">
          <h4 i18n>Scheduling Order</h4>
        </div>
    
        <div class="desription">
          <p i18n>These are repair jobs in your vehicle. Pending requests require your authorization.</p>
        </div>
        }
        <mat-tab-group [(selectedIndex)]="selectedTabIndex" (selectedIndexChange)="selectTab($event)"
            fitInkBarToContent>
            <mat-tab [label]="pendingTabLabel"></mat-tab>
            <mat-tab label="Authorized" i18n-label></mat-tab>
            <mat-tab label="Declined" i18n-label></mat-tab>
        </mat-tab-group>

        <div class="scrollable-section">
            <!-- Cards for ServiceJobs Jobs -->
            @if(schedulingServiceJobs?.length > 0){
            <div>
                @for( job of schedulingServiceJobs; track job.id; let i= $index) {
                <div class="card">
                    <div class="card-content">
                        <div class="card-header">
                            <span>{{ job.categoryName }}</span>
                        </div>
                        <h3>{{ job?.description }}</h3>
                        <span>{{ job?.comment }}</span>
                        @if (job?.descriptionLong) {
                        <div class="description-long">
                            {{ job?.descriptionLong }}
                        </div>
                        }
                    </div>
                    <div class="job-card">
                        <div class="card-job-content">
                            @if (job?.priceSummary?.length > 0) {
                                <div class="price-details">
                                  @for (price of job.priceSummary; track price) {
                                    <div>
                                      <span>{{ priceTypeLabel(price?.type)}}</span>
                                      <span>{{ price?.price?.netPrice | currency: getCurrency(job.priceSummary): 'symbol-narrow' }}</span>
                                    </div>
                                  }
                              
                                  <div>
                                    <span i18n>Discount</span>
                                    <span>{{ getTotalDiscount(job.priceSummary) | currency: getCurrency(job.priceSummary): 'symbol-narrow' }}</span>
                                  </div>
                              
                                  <div>
                                    <span i18n="@@totalInclTax">Total incl. tax ({{ getTotalTaxes(job.priceSummary) | currency: getCurrency(job.priceSummary): 'symbol-narrow' }})</span>
                                    <span class="total">{{ getTotalGrossPrice(job.priceSummary) | currency: getCurrency(job.priceSummary): 'symbol-narrow' }}</span>
                                  </div>
                                </div>
                              }
                              @if (job) {
                                <div class="actions">
                                  @if (job?.approvalStatus !== Approvalstatus.Accept) {
                                    @if (job?.approvalStatus !== Approvalstatus.Reject) {
                                      <button mat-button class="decline" (click)="onButtonGroupClick(Approvalstatus.Reject,job)" i18n>
                                        Decline
                                      </button>
                                    } @else {
                                      <button mat-button class="decline" disabled i18n>
                                        Declined
                                      </button>
                                    }
                                  }
                              
                                  @if (job?.approvalStatus !== Approvalstatus.Reject) {
                                    @if (job?.approvalStatus !== Approvalstatus.Accept) {
                                      <button mat-button color="primary" class="authorize"
                                              (click)="onButtonGroupClick(Approvalstatus.Accept,job)" i18n>
                                        Authorize
                                      </button>
                                    } @else {
                                      <button mat-button color="primary" class="authorize" disabled i18n>
                                        Authorized
                                      </button>
                                    }
                                  }
                                </div>
                                <div class="extra-space"></div>
                              }                              
                        </div>
                    </div>
                </div>
                }
            </div>
            }

            @if(schedulingServiceJobs?.length === 0){
            <div class="no-data-wrapper">
                <div class="no-data-container">
                  <img src="assets/logo/search_off.jpg" alt="No jobs are Available" />
                  <div class="no-jobs-container">
                    <h3>{{ getNoJobsMessage().title }}</h3>
                    <p>{{ getNoJobsMessage().description }}</p>
                  </div>
                </div>
              </div>
            }
        </div>
    </div>

    @if(showFooter){
    <div class="footer">
        <div class="footer-content">
            @if (showDeclineButton && !isAuthorized) {
            <button class="decline-all-button" color="primary" mat-raised-button [disabled]="isDeclineDisabled"
                [ngClass]="{'disabled-button': isDeclineDisabled || (totalPendingJobsCount ?? 0) <= 1}"
                (click)="onApproveAllOrDeclineAllClick(Approvalstatus.Reject)">
                <span i18n>Decline all</span>
                <mat-icon>close</mat-icon>
            </button>
            }

            @if (!isAuthorized) {
            <button class="request-callback-button" color="primary" mat-raised-button
                (click)="onApproveAllOrDeclineAllClick(Approvalstatus.NotProvided)">
                <img src="../../assets/common/request_callback.png" class="request_callback_image"/>
                <span class="callback-text" i18n>Request Callback</span>
            </button>
            }

            @if (showAuthorizeButton) {
            <button class="button-authorize" color="primary" mat-raised-button [disabled]="isAuthorizeDisabled"
                [ngClass]="{'disabled-button': isAuthorizeDisabled || (totalPendingJobsCount ?? 0) <= 1}"
                (click)="onApproveAllOrDeclineAllClick(Approvalstatus.Accept)">
                <span i18n>Authorize all</span>
                <mat-icon>check</mat-icon>
            </button>
            }
        </div>

        <div class="action-bar-container responsive-actions">
            @if (!isAuthorized) {
            <button class="floating-center-btn" (click)="onApproveAllOrDeclineAllClick(Approvalstatus.NotProvided)">
            <img src="../../assets/common/callback.png" />
            </button>
            }
            <div class="action-bar">
                @if (showDeclineButton && !isAuthorized) {
                <button mat-button class="decline-btn" color="primary"
                    [disabled]="isAuthorizeDisabled || (totalPendingJobsCount ?? 0) <= 1"
                    [ngClass]="{'text-disabled': isDeclineDisabled || (totalPendingJobsCount ?? 0) <= 1}"
                    (click)="onApproveAllOrDeclineAllClick(Approvalstatus.Reject)">
                    <mat-icon>close</mat-icon>
                    <span>Decline all</span>
                </button>
                }
                @if (showAuthorizeButton) {
                <button mat-button class="authorize-btn" color="primary"
                    [disabled]="isAuthorizeDisabled || (totalPendingJobsCount ?? 0) <= 1"
                    (click)="onApproveAllOrDeclineAllClick(Approvalstatus.Accept)"
                    [ngClass]="{'text-disabled': isAuthorizeDisabled || (totalPendingJobsCount ?? 0) <= 1}">
                    <mat-icon>check</mat-icon>
                    <span>Authorize all</span>
                </button>
                }

            </div>
        </div>

    </div>
  }
</div>